import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  TextField,
} from "@material-ui/core";
import TextEditorComponent from "../textEditor/TextEditor";
import ImageUpload from "../../containers/upload/imageUpload";
import ResponsiveDatePicker from "../../../components/DatePicker";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    padding: "3vh 3%",
    "@media (max-width: 600px)": {
      padding: "3vh 0%",
      marginLeft: "-15px",
      width: "109%",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardActions: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "15px",
  },
  title: {
    margin: "10px 0",
  },
  input: {
    margin: "10px 0",
  },
}));

export default ({ title, onSubmit, openToast, isLoading, baseContentData }) => {
  const classes = useStyles();
  const [state, setState] = useState(
    baseContentData._id
      ? {
          title: baseContentData.title,
          summary: baseContentData.summary,
          category: baseContentData.category,
          date: baseContentData.date,
          fileUrl: baseContentData.pdfUrl,
        }
      : {
          title: "",
          summary: "",
          category: "",
          date: null,
          fileUrl: "",
        }
  );

  const handleChange = (event) => {
    const { id, value } = event.target;

    setState({ ...state, [id]: value });
  };
  const handleDateChange = (value) => {
    setState((prevState) => ({ ...prevState, date: value }));
  };

  const handleFileUploaded = (fileUrl) =>
    setState((prevState) => ({ ...prevState, fileUrl }));

  const handleSubmit = () => {
    const data = state;
    data.date =
      data.date !== baseContentData.date
        ? data.date.format("YYYY-MM-DD")
        : data.date;
    onSubmit(data);
  };

  return (
    <Container justify="center" maxWidth="md">
      <Card className={classes.cardRoot}>
        <CardHeader title={title || "Article Form"} />
        <CardContent className={classes.cardContent}>
          <TextField
            id="title"
            label="Title"
            variant="outlined"
            className={classes.title}
            value={state.title}
            onChange={handleChange}
            required
          />
          <TextField
            id="category"
            label="Category"
            variant="outlined"
            className={classes.title}
            value={state.category}
            onChange={handleChange}
            required
          />
          <TextField
            id="summary"
            label="Summary"
            multiline
            rows={4}
            value={state.summary}
            onChange={handleChange}
            variant="outlined"
            className={classes.input}
            required
          />
          <br />
          <ResponsiveDatePicker
            value={state.date}
            onValueChange={handleDateChange}
            label="Report's Date"
          />

          <div className={classes.input}>
            <ImageUpload
              onFileUploaded={handleFileUploaded}
              isFileUpload
              defaultImg={state.fileUrl}
              destination="reports"
            />
          </div>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button
            variant="outlined"
            onClick={handleSubmit}
            sx={{
              color: "#E00186",
              border: "1px solid #E00186",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#E00186",
                border: "1px solid #E00186",
              },
            }}
          >
            {isLoading ? "Saving..." : "Save Work"}
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};
